import Vue from 'vue'
import App from './App'
import '../common'

new Vue({
  el: '#app',
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/pages/index/index.js